import React, { useState, useEffect } from "react";
import { useNavigate  } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";

/*** 
@purpose : Functional component
@Parameter : {props}
**/
function PrefectureFunctions(props) {
  const navigate = useNavigate();
  const [customerNotFound, setCustomerNotFound] = useState();
  const [lang] = useTranslation("language");
  const [details, setDetails] = useState({});
  const [typeOne, setTypeOne] = useState({});
  const [typeTwo, setTypeTwo] = useState({});
  const [typeThree, setTypeThree] = useState({});
  const [typeFour, setTypeFour] = useState({});

  useEffect(() => {
    setDetails(props.details);
    setTypeOne(props.typeOne && props.typeOne[0]);
    setTypeTwo(props.typeTwo && props.typeTwo[0]);
    setTypeThree(props.typeThree && props.typeThree[0]);
    setTypeFour(props.typeFour && props.typeFour[0]);
  }, []);

  /*** 
    @purpose : Change route
    @Parameter : {e, page}
    **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  return (
    <>
      <div className="org-main">
        <div className="org-wrapper1">
          <h4 className="primary-title">
            {lang("OrganizationMenu.prefectureFunctions")}
          </h4>
          <div className="card">
            <div className="card-body">
              <div className="table-responsive mb-0 max-height">
                <table className="table" aria-describedby="table">
                  <thead>
                    <tr>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("customerRequestStatus.item")}
                        </div>
                      </th>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("organizationDetails.flag")}
                        </div>
                      </th>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("organizationDetails.value")}
                        </div>
                      </th>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("organizationDetails.approvedDate")}
                        </div>
                      </th>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("organizationDetails.cancelledDate")}
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>情報年月日</td>
                      <td>-</td>
                      <td>
                        {details && details.information_date
                          ? details.information_date
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>案内用ﾎｰﾑﾍﾟｰｼﾞｱﾄﾞﾚｽ</td>
                      <td>-</td>
                      <td>
                        <a
                          href={details && details.homepage_url_for_guidance}
                          target="_blank"
                        >
                          {details.homepage_url_for_guidance
                            ? details.homepage_url_for_guidance
                            : ""}
                        </a>
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>院内処方</td>
                      <td>
                        {details.out_of_hospital_prescription_flag
                          ? details.out_of_hospital_prescription_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>治験の実施</td>
                      <td>
                        {details.conducting_clinical_trial_flag
                          ? details.conducting_clinical_trial_flag
                          : ""}
                      </td>
                      <td>
                        {details.conducting_clinical_trial_number_of_contracts
                          ? details.conducting_clinical_trial_number_of_contracts
                          : ""}
                      </td>
                      <td>
                        {details.conducting_clinical_trial_period_from
                          ? details.conducting_clinical_trial_period_from
                          : ""}
                      </td>
                      <td>
                        {details.conducting_clinical_trial_period_to
                          ? details.conducting_clinical_trial_period_to
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>保有する施設設備</td>
                      <td>
                        {details.owning_facility_equipment_flag
                          ? details.owning_facility_equipment_flag
                          : ""}
                      </td>
                      <td>
                        {typeOne &&
                          typeOne.medical_function_name_1 &&
                          typeOne.medical_function_name_1.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                <span>{item}</span>
                                <br />
                              </React.Fragment>
                            );
                          })}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>対応することができる疾患・治療の内容</td>
                      <td>
                        {details.contents_of_diseases_and_treatments_that_can_be_addressed_flag
                          ? details.contents_of_diseases_and_treatments_that_can_be_addressed_flag
                          : ""}
                      </td>
                      <td>
                        {typeTwo &&
                          typeTwo.medical_function_name_2 &&
                          typeTwo.medical_function_name_2.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                <span>{item}</span>
                                <br />
                              </React.Fragment>
                            );
                          })}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>対応することができる短期滞在手術</td>
                      <td>
                        {details.short_term_stay_surgery_that_can_be_accommodated_flag
                          ? details.short_term_stay_surgery_that_can_be_accommodated_flag
                          : ""}
                      </td>
                      <td>
                        {typeThree &&
                          typeThree.medical_function_name_3 &&
                          typeThree.medical_function_name_3.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                <span>{item}</span>
                                <br />
                              </React.Fragment>
                            );
                          })}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>専門外来</td>
                      <td>
                        {details.specialized_outpatient_flag
                          ? details.specialized_outpatient_flag
                          : ""}
                      </td>
                      <td>
                        {typeFour &&
                          typeFour.medical_function_name_4 &&
                          typeFour.medical_function_name_4.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                <span>{item}</span>
                                <br />
                              </React.Fragment>
                            );
                          })}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>地域医療連携体制_窓口設置</td>
                      <td>
                        {details.regional_medical_cooperation_system_contact_point_flag
                          ? details.regional_medical_cooperation_system_contact_point_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>地域医療連携体制_地域連携ﾊﾟｽ</td>
                      <td>
                        {details.regional_medical_cooperation_system_regional_path_flag
                          ? details.regional_medical_cooperation_system_regional_path_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>入院診療計画策定時における院内の連携体制</td>
                      <td>
                        {details.hospital_collaboration_system_Inpatient_medical_plan_formulation
                          ? details.hospital_collaboration_system_Inpatient_medical_plan_formulation
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>診療情報管理体制_ｵｰﾀﾞﾘﾝｸﾞｼｽﾃﾑ_有無</td>
                      <td>
                        {details.medical_information_management_ordering_system_flag
                          ? details.medical_information_management_ordering_system_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>診療情報管理体制_ｵｰﾀﾞﾘﾝｸﾞｼｽﾃﾑ_検査</td>
                      <td>
                        {details.medical_information_management_ordering_system_Inspection
                          ? details.medical_information_management_ordering_system_Inspection
                          : ""}
                      </td>
                      <td></td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>診療情報管理体制_ｵｰﾀﾞﾘﾝｸﾞｼｽﾃﾑ_処方</td>
                      <td>
                        {details.medical_information_management_ordering_system_prescription
                          ? details.medical_information_management_ordering_system_prescription
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>診療情報管理体制_ｵｰﾀﾞﾘﾝｸﾞｼｽﾃﾑ_予約</td>
                      <td>
                        {details.medical_information_management_ordering_system_reservation
                          ? details.medical_information_management_ordering_system_reservation
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>診療情報管理体制_ICDｺｰﾄﾞ利用</td>
                      <td>
                        {details.medical_information_management_icd_code_usage_flag
                          ? details.medical_information_management_icd_code_usage_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>診療情報管理体制_電子ｶﾙﾃ</td>
                      <td>
                        {details.medical_information_management_electronic_medical_file_flag
                          ? details.medical_information_management_electronic_medical_file_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>診療情報管理体制_専任従事者</td>
                      <td>
                        {details.medical_information_management_full_time_employee_flag
                          ? details.medical_information_management_full_time_employee_flag
                          : ""}
                      </td>
                      <td>
                        従事者数:{" "}
                        {details.medical_information_management_no_of_full_time_employee
                          ? details.medical_information_management_no_of_full_time_employee
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>患者数平均_病床</td>
                      <td>-</td>
                      <td>
                        <table>
                          <thead>
                            <tr>
                              <th scope="col" className="base">全体</th>
                              <th scope="col" className="base">一般</th>
                              <th scope="col" className="base">療養</th>
                              <th scope="col" className="base">療養(医療)</th>
                              <th scope="col" className="base">療養(介護)</th>
                              <th scope="col" className="base">精神</th>
                              <th scope="col" className="base">結核</th>
                              <th scope="col" className="base">感染症</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {details.average_number_of_patients_total_bed
                                  ? details.average_number_of_patients_total_bed
                                  : ""}
                              </td>
                              <td>
                                {details.average_number_of_patients_general_bed
                                  ? details.average_number_of_patients_general_bed
                                  : ""}
                              </td>
                              <td>
                                {details.average_number_of_patients_recuperation_bed
                                  ? details.average_number_of_patients_recuperation_bed
                                  : ""}
                              </td>
                              <td>
                                {details.average_number_of_patients_medical_treatment_bed
                                  ? details.average_number_of_patients_medical_treatment_bed
                                  : ""}
                              </td>
                              <td>
                                {details.average_number_of_patients_nursing_care_bed
                                  ? details.average_number_of_patients_nursing_care_bed
                                  : ""}
                              </td>
                              <td>
                                {details.average_number_of_patients_psychiatric_bed
                                  ? details.average_number_of_patients_psychiatric_bed
                                  : ""}
                              </td>
                              <td>
                                {details.average_number_of_patients_tuberculosis_bed
                                  ? details.average_number_of_patients_tuberculosis_bed
                                  : ""}
                              </td>
                              <td>
                                {details.average_number_of_patients_infectious_disease_bed
                                  ? details.average_number_of_patients_infectious_disease_bed
                                  : ""}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td>
                        {details.average_number_of_patients_type_of_bed_period_from
                          ? details.average_number_of_patients_type_of_bed_period_from
                          : ""}
                      </td>
                      <td>
                        {details.average_number_of_patients_type_of_bed_period_to
                          ? details.average_number_of_patients_type_of_bed_period_to
                          : ""}
                      </td>
                    </tr>
                    {/* done */}
                    <tr>
                      <td>患者数平均_外来</td>
                      <td>-</td>
                      <td>
                        {details.average_number_of_patients_outpatients
                          ? details.average_number_of_patients_outpatients
                          : ""}
                      </td>
                      <td>
                        {details.average_number_of_patients_outpatients_period_from
                          ? details.average_number_of_patients_outpatients_period_from
                          : ""}
                      </td>
                      <td>
                        {details.average_number_of_patients_outpatients_period_to
                          ? details.average_number_of_patients_outpatients_period_to
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>患者数平均_在宅</td>
                      <td>-</td>
                      <td>
                        {details.average_number_of_patients_at_home_patients
                          ? details.average_number_of_patients_at_home_patients
                          : ""}
                      </td>
                      <td>
                        {details.average_number_of_patients_at_home_patients_period_from
                          ? details.average_number_of_patients_at_home_patients_period_from
                          : ""}
                      </td>
                      <td>
                        {details.average_number_of_patients_at_home_patients_period_to
                          ? details.average_number_of_patients_at_home_patients_period_to
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>患者数延数_病床</td>
                      <td>-</td>
                      <td>
                        <table>
                          <thead>
                            <tr>
                              <th scope="col">全体</th>
                              <th scope="col">一般</th>
                              <th scope="col">療養</th>
                              <th scope="col">療養(医療)</th>
                              <th scope="col">療養(介護)</th>
                              <th scope="col">精神</th>
                              <th scope="col">結核</th>
                              <th scope="col">感染症</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {details.accumulated_number_of_patients_total_bed
                                  ? details.accumulated_number_of_patients_total_bed
                                  : ""}
                              </td>
                              <td>
                                {details.accumulated_number_of_patients_normal_bed
                                  ? details.accumulated_number_of_patients_normal_bed
                                  : ""}
                              </td>
                              <td>
                                {details.accumulated_number_of_patients_recuperation_bed
                                  ? details.accumulated_number_of_patients_recuperation_bed
                                  : ""}
                              </td>
                              <td>
                                {details.accumulated_number_of_patients_medical_treatment_bed
                                  ? details.accumulated_number_of_patients_medical_treatment_bed
                                  : ""}
                              </td>
                              <td>
                                {details.accumulated_number_of_patients_nursing_care_bed
                                  ? details.accumulated_number_of_patients_nursing_care_bed
                                  : ""}
                              </td>
                              <td>
                                {details.accumulated_number_of_patients_Psychiatric_bed
                                  ? details.accumulated_number_of_patients_Psychiatric_bed
                                  : ""}
                              </td>
                              <td>
                                {details.accumulated_number_of_patients_tuberculosis_bed
                                  ? details.accumulated_number_of_patients_tuberculosis_bed
                                  : ""}
                              </td>
                              <td>
                                {details.accumulated_number_of_patients_infectious_disease_bed
                                  ? details.accumulated_number_of_patients_infectious_disease_bed
                                  : ""}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td>
                        {details.accumulated_number_of_patients_period_from
                          ? details.accumulated_number_of_patients_period_from
                          : ""}
                      </td>
                      <td>
                        {details.accumulated_number_of_patients_period_to
                          ? details.accumulated_number_of_patients_period_to
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>患者数延数_外来</td>
                      <td>-</td>
                      <td>
                        {details.accumulated_number_of_patients_outpatients
                          ? details.accumulated_number_of_patients_outpatients
                          : ""}
                      </td>
                      <td>
                        {details.accumulated_number_of_patients_outpatients_period_from
                          ? details.accumulated_number_of_patients_outpatients_period_from
                          : ""}
                      </td>
                      <td>
                        {details.accumulated_number_of_patients_outpatients_period_to
                          ? details.accumulated_number_of_patients_outpatients_period_to
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>患者数延数_在宅</td>
                      <td>-</td>
                      <td>
                        {details.accumulated_number_of_patients_at_home_patients
                          ? details.accumulated_number_of_patients_at_home_patients
                          : ""}
                      </td>
                      <td>
                        {details.accumulated_number_of_patients_at_home_patients_period_from
                          ? details.accumulated_number_of_patients_at_home_patients_period_from
                          : ""}
                      </td>
                      <td>
                        {details.accumulated_number_of_patients_at_home_patients_period_to
                          ? details.accumulated_number_of_patients_at_home_patients_period_to
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>平均在院日数_病床</td>
                      <td>-</td>
                      <td>
                        <table>
                          <thead>
                            <tr>
                              <th scope="col">全体</th>
                              <th scope="col">一般</th>
                              <th scope="col">療養</th>
                              <th scope="col">療養(医療)</th>
                              <th scope="col">療養(介護)</th>
                              <th scope="col">精神</th>
                              <th scope="col">結核</th>
                              <th scope="col">感染症</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {details.average_number_of_days_in_hospital_total_bed
                                  ? details.average_number_of_days_in_hospital_total_bed
                                  : ""}
                              </td>
                              <td>
                                {details.average_number_of_days_in_hospital_general_bed
                                  ? details.average_number_of_days_in_hospital_general_bed
                                  : ""}
                              </td>
                              <td>
                                {details.average_number_of_days_in_hospital_recuperation_bed
                                  ? details.average_number_of_days_in_hospital_recuperation_bed
                                  : ""}
                              </td>
                              <td>
                                {details.average_number_of_days_in_hospital_medical_treatment_bed
                                  ? details.average_number_of_days_in_hospital_medical_treatment_bed
                                  : ""}
                              </td>
                              <td>
                                {details.average_number_of_days_in_hospital_nursing_care_bed
                                  ? details.average_number_of_days_in_hospital_nursing_care_bed
                                  : ""}
                              </td>
                              <td>
                                {details.average_number_of_days_in_hospital_psychiatric_bed
                                  ? details.average_number_of_days_in_hospital_psychiatric_bed
                                  : ""}
                              </td>
                              <td>
                                {details.average_number_of_days_in_hospital_tuberculosis_bed
                                  ? details.average_number_of_days_in_hospital_tuberculosis_bed
                                  : ""}
                              </td>
                              <td>
                                {details.average_number_of_days_in_hospital_infectious_disease_bed
                                  ? details.average_number_of_days_in_hospital_infectious_disease_bed
                                  : ""}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td>
                        {details.average_number_of_days_in_hospital_period_from
                          ? details.average_number_of_days_in_hospital_period_from
                          : ""}
                      </td>
                      <td>
                        {details.average_number_of_days_in_hospital_period_to
                          ? details.average_number_of_days_in_hospital_period_to
                          : ""}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="md"
        className="withdraw-modal"
        show={customerNotFound}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">
            <img src="images/warning2.svg" alt="Warning" /> Customer Not Found
          </div>
          <p className="mb-3">
            To search for customers, please go to{" "}
            <a
              className="link"
              onClick={(e) => {
                changeRoute(e, "/organizationCustomer");
              }}
            >
              Organization Customer Inquiry
            </a>
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PrefectureFunctions;
